/* eslint-disable import/first */
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import _merge from 'lodash/merge';
import PropTypes from 'prop-types';
// Date util library
import MomentUtils from '@date-io/moment';
// Material UI
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
// Custom
import DialogsManager from 'components/dialogs/DialogsManager';
import ErrorBoundary from 'components/error/ErrorBoundary';
import ResponseInterceptor from './ResponseInterceptor';

// = styles =
// 3rd
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/ui.scss';
import 'styles/app.scss';
// themes
import main from './themes/main';
import opac from './themes/opac';
// app
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';

// Available themes
const availableThemes = {
  themeOpac: opac,
};

const App = ({
  children,
  layoutBoxed,
  fixedHeader,
  themeOpac,
}) => {
  // Create material UI theme
  const muiTheme = createMuiTheme(availableThemes[themeOpac]);

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <React.Fragment>
        <MuiThemeProvider theme={muiTheme}>
          <MuiThemeProvider theme={(outerTheme) => _merge(outerTheme, main)}>
            <CssBaseline />
            <ResponseInterceptor />
            <ErrorBoundary>
              <div
                className={classnames('w-100 d-flex flex-column', {
                  'fixed-header': fixedHeader,
                  'layout-boxed': layoutBoxed,
                  'theme-gray': themeOpac === 'gray',
                  'theme-dark': themeOpac === 'dark',
                })}
              >
                {children}
              </div>
            </ErrorBoundary>
            <DialogsManager />
          </MuiThemeProvider>
        </MuiThemeProvider>
      </React.Fragment>
    </MuiPickersUtilsProvider>
  );
};

App.propTypes = {
  children: PropTypes.element.isRequired,
  layoutBoxed: PropTypes.bool.isRequired,
  fixedHeader: PropTypes.bool.isRequired,
  themeOpac: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  layoutBoxed: state.settings.layoutBoxed,
  navCollapsed: state.settings.navCollapsed,
  navBehind: state.settings.navBehind,
  fixedHeader: state.settings.fixedHeader,
  sidebarWidth: state.settings.sidebarWidth,
  themeOpac: state.settings.themeOpac,
});

module.exports = connect(
  mapStateToProps,
  null,
)(App);



// WEBPACK FOOTER //
// ./containers/App.js